export const REPORT_TYPE_OPTIONS = [
    { value: 'executive', label: 'Executive', format: 'PDF' },
    { value: 'detailed', label: 'Detailed', format: '.CSV' },
    { value: 'both', label: 'Both', format: 'PDF & .CSV' },
];

export const normalizeReportType = (reportType) => (
    REPORT_TYPE_OPTIONS.some(option => option.value === reportType) ? reportType : 'executive'
);

export const getReportTypeBadges = (reportType) => {
    const normalizedReportType = normalizeReportType(reportType);
    if (normalizedReportType === 'both') {
        return REPORT_TYPE_OPTIONS.filter(option => option.value !== 'both');
    }
    return REPORT_TYPE_OPTIONS.filter(option => option.value === normalizedReportType);
};
